const EventEmitter = require('eventemitter3');

const StandardStrike = require('../StandardStrike');
const BattleCalc = require('../../BattleCalc');
const BattleConfig = require('../../../constants/BattleConfig');
const CCHandler = require('../../CCHandler');
const StunnedCondition = require('../../conditions/StunnedCondition');
const { logError } = require('../../logger');

const Bash = function(battleState) {
  this.handle = 'bash';
  this.physical = true;
  this.harm = true;

  this.standardStrike = new StandardStrike(this, battleState);

  this.eventEmitter = new EventEmitter();

  this.isLegal = function(actor, victim) {
    return victim && victim.unit;
  };

  this.execute = function(actor, victim) {
    if (!actor || !actor.inPlay || !victim || (victim.unit&&!victim.inPlay)) {
      return { success: false };
    }

    try {
      const ability = BattleCalc.getEquippedAbility(actor, this.handle);

      const result = this.standardStrike.execute(
        actor,
        victim,
        ability.damage,
        true,
      );
      result.abilityHandle = this.handle;
      result.actorId = actor.uid;
      result.victimId = victim.uid;
      result.allPieces = battleState.allPieces;

      if (result.success && !victim.dead && !CCHandler.checkForResistStun(victim,battleState)) {
        var stunned = new StunnedCondition(actor, victim, battleState, ability.duration);
        stunned.instigatorId = actor.uid;
        stunned.ownerId = victim.uid;
        battleState.onUnitCondition(stunned);
        result.stunnedCondition = stunned;
      }

      this.eventEmitter.emit('result', result);
    } catch (err) {
      logError(err, {
        module: 'Bash',
        func: 'execute',
        actor,
        victim,
      });

      return { success: false };
    }
  };
};
module.exports = Bash;
